// eslint-disable-next-line import/no-anonymous-default-export
export default {
  API_ENDPOINT: 'https://thawing-plains-80929.herokuapp.com/api',
  TOKEN_KEY: 'blogful-client-auth-token',
}
